module.exports = __webpack_public_path__ + "static/img/gaozhonglishi5.b5b62f70.jpg";